import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../../services/api";
import "./teacher-details.css";

export default function TeacherDetails() {
  const { id } = useParams();
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [teacher, setTeacher] = useState(null);
  const [showPassword, setShowPassword] = useState(true);

  // ================= LOAD TEACHER =================
  const loadTeacher = async () => {
    const res = await API.get(`/school-admin/teachers/${id}/`, {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setTeacher(res.data);
  };

  useEffect(() => {
    loadTeacher();
  }, []);

  const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    alert("Password copied");
  };

  if (!teacher) return <p>Loading...</p>;

  // ================= DELETE =================
  const deleteTeacher = async () => {
    if (!window.confirm("Delete this teacher?")) return;

    await API.delete(`/school-admin/teachers/delete/${id}/`, {
      headers: { "X-SCHOOL-ID": school.school.id },
    });

    alert("Teacher deleted");
    window.location.href = "/school-admin/teachers";
  };

  return (
    /* 🔐 UNIQUE PAGE ID — NO CONFLICT EVER */
    <div id="teacher-details-unique">

      <h2>{teacher.name}</h2>

      {/* ================= PROFILE CARD ================= */}
      <div className="details-card">
        <img
          src={teacher.photo || "/default-user.png"}
          className="details-photo"
          alt="Teacher"
        />

        <div className="details-info">
          <p><strong>Teacher ID:</strong> {teacher.teacher_id}</p>

          {/* PASSWORD */}
          <div className="password-row">
            <p style={{ margin: 0 }}>
              <strong>Password:</strong>{" "}
              <span className="password-text">
                {showPassword ? teacher.teacher_password : "••••••••"}
              </span>
            </p>

            <button
              className="btn-eye"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Hide" : "Show"}
            </button>

            <button
              className="btn-copy"
              onClick={() => copyToClipboard(teacher.teacher_password)}
            >
              Copy
            </button>
          </div>

          <p><strong>Email:</strong> {teacher.email}</p>
          <p><strong>Phone:</strong> {teacher.phone}</p>
          <p><strong>Joining Date:</strong> {teacher.joining_date}</p>
          <p><strong>Address:</strong> {teacher.address}</p>
        </div>
      </div>

      {/* ================= STATS ================= */}
      <div className="stats-grid mt-20">

        <div className="stat-card">
          <h4>📅 Attendance Summary</h4>
          <p>Total Days: <b>{teacher.attendance_summary?.total_days || 0}</b></p>
          <p>Present: <b className="green">{teacher.attendance_summary?.present || 0}</b></p>
          <p>Absent: <b className="red">{teacher.attendance_summary?.absent || 0}</b></p>
          <p>Leave: <b>{teacher.attendance_summary?.leave || 0}</b></p>
        </div>

        <div className="stat-card">
          <h4>💰 Salary Summary</h4>
          <p>Monthly Salary: <b>₹{teacher.salary_summary?.monthly_salary || 0}</b></p>
          <p>Paid Amount: <b className="green">₹{teacher.salary_summary?.paid_amount || 0}</b></p>
          <p>Pending Amount: <b className="red">₹{teacher.salary_summary?.pending_amount || 0}</b></p>
        </div>

      </div>

      {/* ================= ASSIGNMENTS ================= */}
      <h3 className="mt-20">Assigned Classes & Subjects</h3>

      {teacher.assignments?.length === 0 ? (
        <p>No class assignments</p>
      ) : (
        <table className="teacher-table mt-10">
          <thead>
            <tr>
              <th>Class</th>
              <th>Section</th>
              <th>Subject</th>
              <th>Role</th>
            </tr>
          </thead>
          <tbody>
            {teacher.assignments.map((a, i) => (
              <tr key={i}>
                <td>{a.class}</td>
                <td>{a.section}</td>
                <td>{a.subject}</td>
                <td>
                  {a.is_class_teacher ? (
                    <span className="badge-primary">Class Teacher</span>
                  ) : (
                    <span className="badge-secondary">Subject Teacher</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* ================= ACTIONS ================= */}
      <div className="action-buttons mt-20">
        <button
          className="btn-edit"
          onClick={() =>
            (window.location.href = `/school-admin/teachers/edit/${teacher.id}`)
          }
        >
          Edit
        </button>

      </div>

    </div>
  );
}
